import { createContext, useContext } from "react";

import { ISetup } from "./Setup.types";

interface ISetupContext {
  setup: ISetup;
  updateSetup: (payload: ISetup) => void;
}

export const SetupContext = createContext<ISetupContext | null>(null);

/**
 * React hook responsável por acessar o contexto de edição e criação de setup de workspace.
 */
export const useSetup = () => {
  const context = useContext(SetupContext);

  if (!context) {
    throw new Error("You can only use this context inside a Setup component.");
  }

  return context;
};
